export default "__VITE_ASSET__46183626__"